import {
    accentGreen,
    cookieGreen3,
    playGrey20,
    playTransitionCubicEaseInOut,
    regularBlack,
    regularWhite,
} from '@ui-components/design-tokens';
import { PlayListHeading } from '@ui-components/typography/PlayListHeading.styles';
import { VisuallyHidden } from '@ui-components/utils.styles';
import styled, { css, keyframes } from 'styled-components';
import { InputSize, SwitchInputTheme } from './SwitchInput';
import { regularOutline } from '../typography/helpers';

export const SwitchContainer = styled.div<{ size: InputSize }>`
    margin-top: 1em;

    ${({ size }) =>
        size === InputSize.Small &&
        css`
            transform-origin: center right;
            transform: scale(0.8);
        `};
`;

const bounceLeft = keyframes`
    0% {
        left: 27px;
    }

    50% {
        left: 10px;
    }

    100% {
        left: 27px;
    }
`;

const bounceRight = keyframes`
    0% {
        left: 0;
    }

    50% {
        left: 20px;
    }

    100% {
        left: 0;
    }
`;

export const Handle = styled.span<{ checked?: boolean; bounceLeft?: boolean; bounceRight?: boolean }>`
    background: ${regularWhite};
    border: 5px solid ${regularWhite};
    border-radius: 50%;
    display: block;
    width: 18px;
    height: 18px;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    transition: left 200ms ${playTransitionCubicEaseInOut} 0ms;

    ${(props) =>
        props.checked &&
        css`
            left: 27px;
        `}

    ${(props) =>
        props.bounceLeft &&
        css`
            animation: ${bounceLeft} 0.2s, 1 ${playTransitionCubicEaseInOut};
        `}

    ${(props) =>
        props.bounceRight &&
        css`
            animation: ${bounceRight} 0.2s, 1 ${playTransitionCubicEaseInOut};
        `}
`;

export const SwitchLabel = styled.label<{ checked?: boolean; theme: SwitchInputTheme }>`
    display: block;
    overflow: hidden;
    cursor: pointer;
    background-color: ${({ theme }) => (theme === SwitchInputTheme.Secondary ? regularBlack : playGrey20)};
    border-radius: 50px;
    height: 18px;
    transition: bakground-color 200ms ${playTransitionCubicEaseInOut} 0ms;

    ${(props) =>
        props.checked &&
        css`
            background: ${({ theme }) => (theme === SwitchInputTheme.Secondary ? cookieGreen3 : accentGreen)};
        `}
`;

export const Switch = styled.div<{ theme: SwitchInputTheme }>`
    position: relative;
    margin: 10px auto;
    width: 45px;
    user-select: none;
    display: inline-block;
    vertical-align: middle;
    outline: none;

    &:hover ${/* sc-selector */ Handle} {
        background: ${({ theme }) => (theme === SwitchInputTheme.Secondary ? cookieGreen3 : accentGreen)};
    }
    &:focus {
        outline: none;
        ${/* sc-selector */ Handle} {
            background: ${({ theme }) => (theme === SwitchInputTheme.Secondary ? cookieGreen3 : accentGreen)};
        }
    }
`;

export const A11yText = styled.span`
    ${VisuallyHidden};
`;

export const SettingsLabel = styled(PlayListHeading)`
    display: inline-block;
    vertical-align: middle;
    margin-left: 15px;
    max-width: 78%;
`;

export const Checkbox = styled.input`
    ${VisuallyHidden};
    &:focus + ${/* sc-selector */ SwitchLabel}, &:focus-visible + ${/* sc-selector */ SwitchLabel} {
        ${regularOutline(2, regularWhite)}
    }

    &:focus:not(:focus-visible) + ${/* sc-selector */ SwitchLabel} {
        outline: none;
    }
`;
